export default __webpack_public_path__ + "static/media/L.eab8a3d0.wav";